export * from "modules/DealerOverviewDashboard/components/DmsSystem/components/Network/components/DNSRecord";
